import React from 'react'
import styles from './retroConsole.module.css';
console.log(styles)


const RetroConsole = (props) => {
    return (
        <div className={styles.retroConsoleContainer} style={{
            transform: `scale(${props.scale})`,
        }}>
            <div className={styles.mainBody}></div>
            <div className={styles.stand}></div>

            <div className={styles.screen}>
                <div className={styles.screenChildrenWrapper}>
                    {props.children}
                </div>
            </div>

            <div className={styles.powerButton}>
                <span></span>
                <span></span>
            </div>
            <div className={styles.floppyDrive}>
                <span className={styles.floppyDriveSlot}></span>
                <span className={styles.floppyDriveSlotBottom}></span>
                <span className={styles.floppyDriveSlotButton}></span>
                <span className={styles.floppyDriveSlotLight}></span>
            </div>
        </div>
    )
}
export default RetroConsole
